import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import topValidation from 'top-validation';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();



  if (document.body.classList.contains('recruit') ) {
    topValidation();
  }





  const menuBtn = document.querySelector('.hd_toggle');
  const navHeader = document.querySelector('.header');

  menuBtn.addEventListener('click', function() {
    this.classList.toggle('is_active');

    if (this.classList.contains('is_active')) {
      navHeader.classList.add('is_active');
    } else {
      navHeader.classList.remove('is_active');
    }
  });




  var recruitBnr = document.querySelector('.recruit_bnr_block');
  var footer = document.querySelector('.footer');
  var toggle = document.querySelector('.hd_toggle');
  var viewportHeight = 0.3 * window.innerHeight;
  var winHeight = 0.1 * window.innerHeight;

  if (recruitBnr || toggle) {  // recruitBnr または toggle が存在する場合のみ実行
    window.addEventListener('load', handleScroll);
    window.addEventListener('scroll', handleScroll);
  }

  function handleScroll() {
    // フッターの位置を取得
    var footerTop = footer.getBoundingClientRect().top + window.scrollY;

    // recruitBnr の表示/非表示処理
    if (recruitBnr) {
      if (window.scrollY > viewportHeight && !recruitBnr.classList.contains('show')) {
        recruitBnr.classList.add('show');
      } else if (window.scrollY < viewportHeight && recruitBnr.classList.contains('show')) {
        recruitBnr.classList.remove('show');
      }

      // recruitBnr が footer に到達したらクラスを外す
      if (window.scrollY + window.innerHeight > footerTop) {
        recruitBnr.classList.remove('show');
      }
    }

    // toggle の表示/非表示処理
    if (toggle) {
      if (window.scrollY > winHeight && !toggle.classList.contains('show')) {
        toggle.classList.add('show');
      } else if (window.scrollY < winHeight && toggle.classList.contains('show')) {
        toggle.classList.remove('show');
      }
    }
  }






  // ページ内スクロール
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const speed = 600;
      const href = this.getAttribute("href");
      const target = document.querySelector(href === "#" || href === "" ? "html" : href);
      let position = target.getBoundingClientRect().top + window.pageYOffset - 120;

      if (window.matchMedia('(max-width:768px)').matches) {
        position = target.getBoundingClientRect().top + window.pageYOffset - 50;
      }

      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    });
  });


  document.querySelectorAll('.sub_link').forEach(function(link) {
    link.addEventListener('click', function() {
      document.querySelectorAll('.nav_down.black').forEach(function(element) {
        element.classList.remove('black');
      });
    });
  });


  const DownElements = document.querySelectorAll('.nav_down');
  const Header = document.querySelector('.header');

  // 画面幅が1025px以上の時だけイベントを追加する関数
  function addHoverEffect() {
    if (window.innerWidth >= 1025) {
      DownElements.forEach(function(Down) {
        Down.addEventListener('mouseover', addBlackClass);
        Down.addEventListener('mouseleave', removeBlackClass);
      });
    } else {
      DownElements.forEach(function(Down) {
        Down.removeEventListener('mouseover', addBlackClass);
        Down.removeEventListener('mouseleave', removeBlackClass);
      });
    }
  }


  // 黒クラスを追加する関数
  function addBlackClass(event) {
    Header.classList.add('black');
    event.currentTarget.classList.add('black'); // マウスオーバーされた.nav_downにも.blackを追加
  }

  // 黒クラスを削除する関数
  function removeBlackClass(event) {
    Header.classList.remove('black');
    event.currentTarget.classList.remove('black'); // マウスオーバーが外れた.nav_downから.blackを削除
  }

  // 初回実行
  addHoverEffect();

  // 画面サイズが変更された時の処理
  window.addEventListener('resize', addHoverEffect);




  setTimeout(function() {
    document.querySelectorAll('.index_mv_circle').forEach(function(boxWrap) {
        boxWrap.querySelectorAll('.circle').forEach(function(box, index) {
            setTimeout(function() {
                box.classList.add('active');
            }, index * 500); // 各ボックスに300msの遅延を順次適用
        });
    });
  }, 300); // ページ読み込み後5秒待つ


  setTimeout(function() {
    document.querySelectorAll('.page_mv_circle').forEach(function(boxWrap) {
        boxWrap.querySelectorAll('.circle').forEach(function(box, index) {
            setTimeout(function() {
                box.classList.add('active');
            }, index * 500); // 各ボックスに300msの遅延を順次適用
        });
    });
  }, 0); // ページ読み込み後5秒待つ







  const swiper = new Swiper(".index_slider", {
    centeredSlides: true,
    slidesPerView: 2,
    breakpoints: {
      769: {
        slidesPerView: 3.88,
      }
    },
    loop: true,
    speed: 1500,
    // autoplay: {
    //   delay: 5000,
    //   pauseOnMouseEnter: false,
    // },
  });


  // サムネイル
  const sliderThumbnail = new Swiper(".slider-thumbnail", {
    slidesPerView: 3, // サムネイルの枚数
    loop: true,
    speed: 1000,
  });
  // スライダー
  const slider = new Swiper(".slider", {
    loop: true,
    speed: 1000,
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
  });





  window.addEventListener('scroll', function() {
    const elements = document.getElementsByClassName('line');

    if (elements.length > 0) { // 'line'クラスの要素が存在するか確認
        const window_height = window.innerHeight; // 現在のブラウザの高さを取得する

      for (let i = 0; i < elements.length; i++) {
          const element_height = elements[i].getBoundingClientRect().bottom; // 要素の位置（座標）を取得する

        if (element_height < window_height * 0.8) {
          elements[i].classList.add('line-animation');
        } else {
          elements[i].classList.remove('line-animation');
        }
      }
    }
  });


  var rellax = new Rellax('.rellax', {
    breakpoints: [576, 768, 1024],
  });


});
